import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-dark-900 p-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/" className="text-gray-400 hover:text-white inline-flex items-center">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
        </div>

        <div className="card p-8 space-y-6">
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
          
          <section className="space-y-4">
            <h2 className="text-xl font-semibold">1. Introduction</h2>
            <p>
              At Network Relationship Manager (NRM), we take your privacy extremely seriously. 
              This Privacy Policy explains how we collect, use, and protect your personal information.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">2. Data Collection and Use</h2>
            <p>We collect only the minimum information necessary to provide our service:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Account information (email, password)</li>
              <li>Contact information you choose to store</li>
              <li>Email integration data (when explicitly authorized)</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">3. Data Protection</h2>
            <p>We implement strict security measures:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>End-to-end encryption for sensitive data</li>
              <li>Regular security audits</li>
              <li>Secure data storage practices</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">4. No Data Sharing</h2>
            <p>We DO NOT:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Sell your data to third parties</li>
              <li>Share your information with advertisers</li>
              <li>Provide data to external analytics services</li>
              <li>Allow third-party access to your information</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">5. Contact</h2>
            <p>
              For privacy-related questions, contact us at{' '}
              <a href="mailto:privacy@nrm.example.com" className="text-primary-500 hover:underline">
                contact@neosavvy.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}